import { AddressModel } from "../../app/data/common/address";

export  const formatAddress = (address: AddressModel) => (`${address.address1}, ${address.city}, ${address.state} ${address.postalCode || ''}`);